
import { computed } from 'vue'
import { CImportBase, CImportInformation } from '@invivodf/common/src/contexts/parameters'
import { capitalize } from 'lodash'
import { useStore } from '@/composables/useStore'
import { salesStoresService } from '@/services'

const csvFileProperties = {
  name: 'sales-stores.csv',
  full_path: '/assets/csv/sales-stores.csv',
}

export default {
  name: 'CImportSalesStores',
  components: {
    CImportBase,
    CImportInformation,
  },
  setup() {
    const store = useStore()

    const SalesStoresImportInformation = computed(() => {
      return store.getters.salesStoresImportInformation
    })
    const distributorId = computed(() => {
      return store.getters.cooperativeId
    })
    const partner = computed(() => {
      return store.getters.cooperative
    })

    const importInformation = computed(() => {
      return {
        count: SalesStoresImportInformation.value?.salesStoresCount,
        lastImportAt: SalesStoresImportInformation.value?.lastSalesStoresImportAt,
      }
    })

    function afterSalesStoresImport() {
      store.dispatch('setSalesStoresImportInformation')
    }

    function downloadCSV() {
      return salesStoresService.downloadSalesStores(distributorId.value, partner.value.name)
    }

    return {
      afterSalesStoresImport,
      capitalize,
      csvProperties: csvFileProperties,
      downloadCSV,
      importInformation,
      partner,
      distributorId,
      SalesStoresImportInformation,
      salesStoresService,
      store,
    }
  },
}
